import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAward } from '@fortawesome/free-solid-svg-icons';
export default function Achievements() {
  return (
    <><div className='text-4xl text-center my-5'>Achievements & Skills</div>
    <div className='grid grid-cols-1 md:grid-cols-2 mx-9 xl:mx-24'>
        <div className=' shadow-xl space-x-8 flex p-2 m-2   items-center ' >
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' /><p>Selected in <strong> Smart India Hackathon</strong> conducted by <strong>Government of India</strong> in March 2022(Screening round). </p>
        </div>
        <div className='shadow-xl  space-x-4 flex m-4 p-5 items-center '>
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' />
             <p >Got <strong>98th</strong> rank in June Long challenge </p>
        </div>
        <div className=' shadow-xl space-x-8 flex p-2 m-2   items-center ' >
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' /><p> <strong>Knight </strong> badge Holder in <strong>LeetCode</strong> with rating of 1889 </p>
        </div>
        <div className='shadow-xl  space-x-4 flex m-4 p-5 items-center '>
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' />
             <p ><strong>Pupil</strong>in <strong>CodeForces</strong></p>
        </div>
        <div className='shadow-xl flex m-4 p-5 items-center '>
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' />
             <p>Working as<strong>campus Ambassador of</strong>IIIC in<strong>IIIT Allahabad</strong> </p>
        </div>
        <div className='shadow-xl flex m-4 p-5 items-center '>
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' />
             <p><strong>3⭐</strong>in<strong>Codechef</strong> </p>
        </div>
        <div className='shadow-xl flex m-4 p-5 items-center '>
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' />
             <p><strong>5⭐</strong>in<strong>HackerRank</strong> </p>
        </div>
        <div className='shadow-xl flex m-4 p-5 items-center '>
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' />
              <p >Got <strong>174th</strong> rank in starters 47 challenge </p>
        </div>
        <div className='shadow-xl flex m-4 p-5 items-center '>
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' />
              <p >Got <strong>256th</strong> rank in June Lunchtime challenge </p>
        </div>
        <div className='shadow-xl flex m-4 p-5 items-center '>
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' />
             <p ><strong>MERN stack Developer and Tailwind css</strong>  </p>
        </div>
        <div className='shadow-xl flex m-4 p-5 items-center '>
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' />
             <p > <strong>Data Stuctures and ALgorithms</strong></p>
        </div>
        <div className='shadow-xl flex m-4 p-5 items-center '>
        <FontAwesomeIcon icon={faAward} size='xl' className='w-10 ml-10' />
             <p><strong>Adobe Photshop(basic)</strong> </p>
        </div>
    
    </div>

    </>
  )
}
